import { useDebounce } from "@opendash/core";
import { AutoComplete, Form } from "antd";
import { Rule } from "antd/es/form";
import { useWatch } from "antd/es/form/Form";
import Parse from "parse";
import React from "react";

type Props = {
  index: number;
  styles: React.CSSProperties;
  rules: Rule[];
  label: string;
};

export default (props: Props) => {
  const [options, setOptions] = React.useState([]);
  const className = useWatch<string>("className");
  const fieldvalue = useWatch<string>(["operations", props.index, "value"]);
  const field = useWatch<any>(["operations", props.index, "field"]);
  const fieldValueDebounced = useDebounce(fieldvalue, 1000);

  React.useEffect(() => {
    if (!className || !field) return;
    const optionQuery = new Parse.Query(className)
      .limit(1000)
      .include(field.value);
    if (fieldValueDebounced) {
      optionQuery.contains(field.value, fieldValueDebounced);
    }

    optionQuery.find().then((results) => {
      const valueSet = {} as Record<string, string>;
      results.forEach((result) => {
        valueSet[result.get(field.value)] = result.get(field.value);
      });
      setOptions(
        Object.keys(valueSet).map((result) => ({
          value: result,
          label: result,
        }))
      );
    });
  }, [className, field?.value, fieldValueDebounced]);
  return (
    <Form.Item
      label={props.label}
      name={[props.index, "value"]}
      rules={props.rules}
      style={props.styles}
    >
      <AutoComplete options={options} />
    </Form.Item>
  );
};
